import request from 'superagent'
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { camelize } from 'src/misc'

export default () => {
  // set dropdown values from local storage
  const usersIndexSelectRole = localStorage.getItem("usersIndexSelectRole")
  if (usersIndexSelectRole) {
    $("#select-role").val(usersIndexSelectRole)
  }
  const usersIndexSelectBu = localStorage.getItem("usersIndexSelectBu")
  if (usersIndexSelectBu) {
    $("#select-bu").val(usersIndexSelectBu)
  }

	// datatable init
  let usersDatatable = $('#users-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('usersIndexPageLength') || 25),
    "processing": true,
    "responsive": true,
    "serverSide": true,
    "ajax": {
      "url": $('#users-datatable').data('source'),
      "data": function (d) {
        d.role = $('#select-role').val()
        d.bu = $('#select-bu').val()
      }
    },
    "columns": [
      { "data": "first_name" },
      { "data": "last_name" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "role" },
      { "data": "title" },
      { "data": "company" },
      { "data": "business_units" },
      { "data": "sign_in_count" },
      { "data": "current_sign_in_at" },
      { "data": "actions", "orderable": false }
    ],
    initComplete(settings, json) {
      $("#datatable-actions").prependTo('#users-datatable_wrapper')
      $("#users-datatable_length").prependTo('#datatable-actions')
      $("#users-datatable_length").addClass('me-3')
      $("#users-datatable_filter input").removeClass('form-control-sm')
      $("#users-datatable_filter input").addClass('datatable-search')
      $('#users-datatable_filter input').attr("type", 'text')
      $("#users-datatable_filter input").detach().prependTo('#search-div')
      $('#users-datatable_wrapper .row:first').remove()
      $("#datatable-actions").removeClass('d-none')

      $('.datatable-search').on('input', function() {
        if ($('#search-div input').val()) {
          $('.clear-button').removeClass('d-none')
        } else {
          $('.clear-button').addClass('d-none')
        }
      })
  	}
  })

  $('#content').on('change', "[name='users-datatable_length']", function() {
    localStorage.setItem('usersIndexPageLength', $(this).val())
  })

  $('#content').on('change', '#select-role, #select-bu', function() {
    localStorage.setItem(camelize('users-index-' + $(this).attr('id')), $(this).val())
    usersDatatable.ajax.reload()
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    usersDatatable.search('').draw()
  })

  $('#content').on('click', '#add_user', function() {
    lockButton('#add_user')
    offcanvasRight.show()
    $.getScript('/users/new')
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    $(this).blur()

    if ($("body.users.index").length) {
      lockButton('#confirmDelete')
      let params = $('#confirmDelete').data('id')
      let p = ''
      if ($('#transferCustomers').length) {
        p += '?new_customer_id=' + $('#transferCustomers').val()
      }
      if ($('#transferEvents').length) {
        if (p.length > 0) {
          p += '&'
        } else {
          p += '?'
        }
        p += 'new_event_id=' + $('#transferEvents').val()
      }
      params += p
      
      request.delete(`/users/${params}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          addToast(res.body.success, 'notice')
          usersDatatable.ajax.reload()
          mainModal.hide()
          $('#offcanvasRight .btn-close').click()
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })

  $('#content').on('click', '.delete-user', function(event) {
    lockButton(event.target)

    const id = $(this).data('id')

    request.get('/delete_user_data?id=' + id)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        let select = ''
        if (res.body.users) {
          select = '<br><br>' + I18n.t("delete_user_modal.transfers_customers") + ' <select id="transferCustomers" class="form-select">'
          let selected = false
          for(let i in res.body.users) {
            let setSelected = ''
            if (!selected && res.body.bu !== null && res.body.users[i].business_unit_ids !== null) {
              if (res.body.users[i].business_unit_ids.includes(res.body.bu.id)) {
                setSelected = ' selected="selected"'
                selected = true
              }
            }
            let name = res.body.users[i].first_name + ' ' + res.body.users[i].last_name
            select += '<option' + setSelected + ' value="' + res.body.users[i].id + '">' + name + '</option>'
          }
          select += '</select>'

          select += '<br>' + I18n.t("delete_user_modal.transfer_events") + ' <select id="transferEvents" class="form-select">'
          selected = false
          for(let i in res.body.users) {
            let setSelected = ''
            if (!selected && res.body.bu !== null && res.body.users[i].business_unit_ids !== null) {
              if (res.body.users[i].business_unit_ids.includes(res.body.bu.id)) {
                setSelected = ' selected="selected"'
                selected = true
              }
            }
            let name = res.body.users[i].first_name + ' ' + res.body.users[i].last_name
            select += '<option' + setSelected + ' value="' + res.body.users[i].id + '">' + name + '</option>'
          }
          select += '</select>'
        }

        $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + I18n.t("delete_modal.title") + '</h4><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body">' + I18n.t("delete_modal.body") + select + '</div><div class="modal-footer"><button id="confirmDelete" type="button" class="btn btn-danger" data-id="' + id + '"><i class="bi bi-trash"></i> ' + I18n.t("buttons.delete") + '</button></div></div></div>')
          mainModal.show()

          unlockButton(event.target)
      })
      .catch(err => {
        handleErrors(err, event.target)
      })
  })

  $('#content').on('click', '.transfer-user-data', function(event) {
    lockButton(event.target)

    const id = $(this).data('id')
    const bu_id = $(this).data('bu_id')

    request.get('/search_users?role=ADMIN,PP,PEM,PO')
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        let select = '<div class="form-group form-floating"><select id="transfer-user-data-user-select" class="form-select">'
        const a = res.body
        let selected = false
        for(let i in a) {
          if (a[i].id !== id) {
            let setSelected = ''
            if (!selected && bu_id && a[i].businessUnitIds !== null) {
              if (a[i].businessUnitIds.includes(bu_id)) {
                setSelected = ' selected="selected"'
                selected = true
              }
            }
            select += '<option' + setSelected + ' value="' + a[i].id + '">' + a[i].fullName + '</option>'
          }
        }
        select += '</select><label for="transfer-user-data-user-select">Käyttäjä</label></div>'

        let checkboxes = '<div class="form-group"><input class="form-check-input" type="checkbox" value="1" id="transfer-user-data-customers"><label for="transfer-user-data-customers" class="ms-1">' + I18n.t("transfer_user_data_modal.customers") + '</label></div>'
        checkboxes += '<div class="form-group"><input class="form-check-input" type="checkbox" value="1" id="transfer-user-data-quality-controls"><label for="transfer-user-data-quality-controls" class="ms-1">' + I18n.t("transfer_user_data_modal.quality_controls") + '</label></div>'

        $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + I18n.t("transfer_user_data_modal.title") + '</h4><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body">' + select + checkboxes + '</div><div class="modal-footer"><button id="confirmTransferUserData" type="button" class="btn btn-success" data-id="' + id + '"><i class="bi bi-check-lg"></i> ' + I18n.t("buttons.transfer") + '</button></div></div></div>')
          mainModal.show()

          unlockButton(event.target)
      })
      .catch(err => {
        handleErrors(err, event.target)
      })
  })

  $('#mainModal').on('click', '#confirmTransferUserData', function(event) {
    const customer = $('#transfer-user-data-customers').is(':checked')
    const qualityControls = $('#transfer-user-data-quality-controls').is(':checked')

    if (customer || qualityControls) {
      lockButton('#confirmTransferUserData')

      let params = '?user_id=' + $(this).data('id')
      params += '&new_user_id=' + $('#transfer-user-data-user-select').val()
      if (customer) {
        params += '&customers=true'
      }
      if (qualityControls) {
        params += '&quality_controls=true'
      }
      
      request.post('/move_user_data' + params)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          addToast(res.body.success, 'notice')
          mainModal.hide()
        })
        .catch(err => {
          handleErrors(err, '#confirmTransferUserData')
        })
    } else {
      addToast(I18n.t("errors.no_transfer_data"), 'alert')
    }
  })
}
